(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[268],{

/***/ 32180:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams/[slug]",
      function () {
        return __webpack_require__(39247);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/app/hocs/PageLayoutV1.tsx + 1 modules
var PageLayoutV1 = __webpack_require__(75019);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/app/components/hocs/HorizontalHIDLayoutHoc.tsx



var HorizontalHIDLayoutHoc = function(param) {
    var header = param.header, image = param.image, children = param.children, className = param.className;
    var classes = classnames_default()("horizontal-hid-layout-hoc", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hid-img-container desktop",
                children: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hid-detail-container",
                children: [
                    header,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hid-img-container mobile",
                        children: image
                    }),
                    children
                ]
            })
        ]
    });
};
/* harmony default export */ var hocs_HorizontalHIDLayoutHoc = (HorizontalHIDLayoutHoc);

;// CONCATENATED MODULE: ./src/app/components/experts/SimpleExpertDetailCard.tsx



var SimpleExpertDetailCard = function(props) {
    var ref, ref1, ref2;
    var expert = props.expert, className = props.className, classes = classnames_default()("simple-expert-detail-card", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(hocs_HorizontalHIDLayoutHoc, {
            header: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sed-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "first-name",
                                children: expert.firstName
                            }),
                            expert.lastName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "last-name",
                                        children: expert.lastName
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            ((ref = expert.credentials) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: ",\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "credentials",
                                        children: expert.credentials.join(", ")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    }),
                    expert.position ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "position",
                        children: expert.position
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            }),
            image: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "avatar",
                src: ((ref1 = expert.image) === null || ref1 === void 0 ? void 0 : ref1.src) || "",
                loading: "lazy",
                width: 300,
                height: 311,
                alt: expert.slug
            }),
            children: [
                ((ref2 = expert.affiliations) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "affiliations",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            children: "Professional Affiliations"
                        }),
                        expert.affiliations.map(function(affiliate, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: affiliate
                            }, idx);
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                expert.contact ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "contacts",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            children: "Contact Information"
                        }),
                        expert.contact.phone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Phone Number: ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:".concat(expert.contact.phone),
                                    children: expert.contact.phone
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        expert.contact.fax ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Fax Number: ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:".concat(expert.contact.fax),
                                    children: expert.contact.fax
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        expert.contact.email ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Email: ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:".concat(expert.contact.email),
                                    children: expert.contact.email
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "socials",
                    children: expert.linkedinUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "link social-link",
                        href: expert.linkedinUrl,
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: "LinkedIn"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                })
            ]
        })
    });
};
/* harmony default export */ var experts_SimpleExpertDetailCard = (SimpleExpertDetailCard);

// EXTERNAL MODULE: ./src/app/utilities/constants.ts
var constants = __webpack_require__(46613);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
;// CONCATENATED MODULE: ./pages/teams/[slug].tsx








var TeamDetailPage = function(props) {
    var ref, ref1, ref2;
    var expert = props.expert, expertFullName = [
        expert.firstName,
        expert.lastName
    ].join(" "), expertCredentials = expert.credentials.join(", "), expertMetaDescription = (0,helpers/* sliceMetaDescription */.rJ)(expert.description.text);
    /**
   * Meta contents
   */ var metaTitle = constants/* META_TITLE */.k5 || "", metaDescription = constants/* META_DESCRIPTION */.KM || "", metaUrl = constants/* META_URL */.f1 || "", metaOgImg = constants/* META_URL */.f1 + "/logo.png", metaTwitterImg = constants/* META_URL */.f1 + "/logo.png";
    if (expert) {
        var ref3, ref4;
        metaTitle = "".concat(expertFullName, " | Heritage Counseling");
        metaDescription = expertMetaDescription || metaDescription;
        metaUrl = "".concat(constants/* META_URL */.f1, "/teams/").concat(expert.slug);
        metaOgImg = ((ref3 = expert.image) === null || ref3 === void 0 ? void 0 : ref3.url) || metaOgImg;
        metaTwitterImg = ((ref4 = expert.image) === null || ref4 === void 0 ? void 0 : ref4.url) || metaTwitterImg;
    }
    // Override metas using pageMeta
    var pageMeta = (expert === null || expert === void 0 ? void 0 : expert.meta) || {};
    if (Object.keys(pageMeta).length > 0) {
        var ref5, ref6;
        metaTitle = (pageMeta === null || pageMeta === void 0 ? void 0 : pageMeta.title) || metaTitle;
        metaDescription = (pageMeta === null || pageMeta === void 0 ? void 0 : pageMeta.description) || metaDescription;
        metaOgImg = (pageMeta === null || pageMeta === void 0 ? void 0 : (ref5 = pageMeta.ogImage) === null || ref5 === void 0 ? void 0 : ref5.url) || metaOgImg;
        metaTwitterImg = (pageMeta === null || pageMeta === void 0 ? void 0 : (ref6 = pageMeta.twitterImage) === null || ref6 === void 0 ? void 0 : ref6.url) || metaTwitterImg;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLayoutV1/* default */.Z, {
        title: expertFullName,
        tagline: expertCredentials,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: metaTitle
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaOgImg
                    }, "og:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: metaUrl
                    }, "twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: metaTwitterImg
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "title",
                        content: metaTitle
                    }, "prop:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "description",
                        content: metaDescription
                    }, "prop:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    }),
                    (expert === null || expert === void 0 ? void 0 : expert.schema) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(expert.schema)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "team-detail-page",
                "data-testid": "team-detail-page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "mb-5 mb-lg-10",
                        role: "navigation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/teams",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "link-back",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-angle-left"
                                    }),
                                    "Back to Teams"
                                ]
                            })
                        })
                    }),
                    expert ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(experts_SimpleExpertDetailCard, {
                                expert: expert
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "bio",
                                dangerouslySetInnerHTML: {
                                    __html: expert.bio.html
                                }
                            }),
                            !!((ref = expert.area_of_expertises) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "specialties",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "title",
                                        children: "Specialties"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "auto-grid service-links",
                                        children: expert.area_of_expertises.map(function(service, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/services/".concat(service.typeSlug, "/").concat(service.slug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "link",
                                                    children: service.name
                                                })
                                            }, idx);
                                        })
                                    })
                                ]
                            }),
                            !!((ref1 = expert.issues_treated) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "issues",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "title",
                                        children: "Issues Treated"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "auto-grid service-links",
                                        children: expert.issues_treated.map(function(service, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/services/".concat(service.typeSlug, "/").concat(service.slug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "link",
                                                    children: service.name
                                                })
                                            }, idx);
                                        })
                                    })
                                ]
                            }),
                            !!((ref2 = expert.blogs) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "blogs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "title",
                                        children: "Blogs"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "",
                                        children: expert.blogs.map(function(blog, idx) {
                                            var ref;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/blogs/".concat(blog.slug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "blog-link",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "img-blog",
                                                            src: ((ref = blog.featuredImage) === null || ref === void 0 ? void 0 : ref.src) || "",
                                                            alt: blog.title,
                                                            height: 70,
                                                            width: 70
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "blog-body",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                className: "blog-title",
                                                                children: blog.title
                                                            })
                                                        })
                                                    ]
                                                })
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center",
                        children: "No experts found"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "mt-5 mt-lg-10",
                        role: "navigation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/teams",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "link-back",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-angle-left"
                                    }),
                                    "Back to Teams"
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (TeamDetailPage);


/***/ }),

/***/ 75019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hocs_PageLayoutV1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./public/static/images/layout/layout-hero-1440.jpg
/* harmony default export */ var layout_hero_1440 = ({"src":"/_next/static/media/layout-hero-1440.020fe420.jpg","height":318,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAEAAgMBAAAAAAAAAAAAAAABAAIFElFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCRLWMQhZDbvjERJi//2Q==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
;// CONCATENATED MODULE: ./src/app/hocs/PageLayoutV1.tsx






var PageLayoutV1 = function(param) {
    var title = param.title, tagline = param.tagline, children = param.children, fluidContainer = param.fluidContainer, noPadding = param.noPadding;
    var isContainerFluid = (0,helpers/* isNullOrUndefined */.le)(fluidContainer) ? false : fluidContainer, containerClasses = classnames_default()("layout-container", {
        container: !isContainerFluid,
        "no-padding": !!noPadding
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-v1",
        "data-testid": "layout-v1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: layout_hero_1440.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "layout-hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "title-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "title",
                            children: title || "Heritage Consulting"
                        }),
                        tagline ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tagline",
                            children: tagline
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: containerClasses,
                children: children
            })
        ]
    });
};
/* harmony default export */ var hocs_PageLayoutV1 = (PageLayoutV1);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(32180); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);